import { render, staticRenderFns } from "./PublicSpotlights.vue?vue&type=template&id=552f3d5b&"
import script from "./PublicSpotlights.vue?vue&type=script&lang=js&"
export * from "./PublicSpotlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports